<template>
  <button
    buttonName="Export"
    :disabled="isExporting"
    @click="click"
    class="btn btn--sm btn--flex btn-filter"
  >
    <div class="btn--text" v-if="isExporting">Exporting...</div>
    <div class="btn--text" v-else>Export</div>
    <span class="btn--icon">
      {{ " " }} &nbsp;
      <svg
        fill="none"
        height="12"
        viewBox="0 0 14 18"
        width="14"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M6.25 0V12.4219L2.28906 8.46094L1.21094 9.53906L6.46094 14.7891L7 15.3047L7.53906 14.7891L12.7891 9.53906L11.7109 8.46094L7.75 12.4219V0H6.25ZM0.25 16.5V18H13.75V16.5H0.25Z"
          fill="#e00b5b"
        />
      </svg>
    </span>
  </button>
</template>
<script>
import startCase from "lodash/startCase";
export default {
  name: "ExportButton",
  props: {
    isExporting: {
      type: Boolean,
      default: false,
    },
    click: {
      type: Function,
      default: () => {},
    },
  },
};
</script>
<style lang="scss">
.empty__text {
  &__caption {
    max-width: 300px;
    line-height: 24px;
  }
}
.text-light {
  font-style: normal;
  font-weight: normal;
  font-size: 16px;
  line-height: 24px;
  color: #595959;
  span {
    color: #e00b5b;
    cursor: pointer;
  }
}
.filter-title {
  font-style: normal;
  font-weight: normal;
  font-size: 13px;
  line-height: 14px;
  color: #9a9fa3;
  margin-bottom: 16px;
}
.btn-filter {
  height: 50px;
  border: 1px solid #fd8387;
  box-sizing: border-box;
  border-radius: 4px;
  background: transparent !important;
}
</style>